import React, { useState } from "react";
import clienteAxios from "../../axios";

const ModalAgregarPago = ({ show, onClose, comandaId, onPagoAgregado }) => {
    const [nuevoPago, setNuevoPago] = useState({
        metodo_pago: "",
        monto: "",
        fecha_pago: "",
    });

    // Función para manejar el cambio de los campos del formulario
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNuevoPago({ ...nuevoPago, [name]: value });
       
    };

    // Función para manejar el envío del formulario
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Logs para verificar los datos antes de enviar
      

        // Validar si todos los campos están completos
        if (nuevoPago.metodo_pago.trim() === "" || nuevoPago.monto.trim() === "" || nuevoPago.fecha_pago.trim() === "") {
           
            alert("Todos los campos son requeridos.");
            return;
        }

        try {
            // Llamada a la API
           
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "pagos",
                comanda_id: comandaId,
                metodo_pago: nuevoPago.metodo_pago,  // Cambiado a "metodo_pago"
                monto: nuevoPago.monto,
                fecha_pago: nuevoPago.fecha_pago,  // Cambiado a "fecha_pago"
            });

            // Verificar la respuesta de la API
            

            // Limpiar el formulario y cerrar el modal si la respuesta es correcta
            setNuevoPago({ metodo_pago: "", monto: "", fecha_pago: "" });
            onPagoAgregado(); // Actualiza la lista de pagos
            onClose(); // Cierra el modal
        } catch (error) {
            // Manejar errores
            console.error("Error al agregar el pago:", error);
           
        }
    };

    // Si el modal no debe mostrarse, no renderizamos nada
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-xl font-bold mb-4">Agregar Nuevo Pago</h2>

                <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
                    <div>
                        <label htmlFor="metodo_pago" className="block font-semibold">Método de Pago</label>
                        <input
                            type="text"
                            id="metodo_pago"
                            name="metodo_pago"
                            value={nuevoPago.metodo_pago}
                            onChange={handleInputChange}
                            className="border rounded-lg p-2 w-full"
                            placeholder="Método de Pago (e.g. Tarjeta de Crédito)"
                            maxLength={20}
                        />
                    </div>
                    <div>
                        <label htmlFor="monto" className="block font-semibold">Monto</label>
                        <input
                            type="number"
                            id="monto"
                            name="monto"
                            value={nuevoPago.monto}
                            onChange={handleInputChange}
                            className="border rounded-lg p-2 w-full"
                            placeholder="Monto"
                            maxLength={10}
                        />
                    </div>
                    <div>
                        <label htmlFor="fecha_pago" className="block font-semibold">Fecha de Pago</label>
                        <input
                            type="date"
                            id="fecha_pago"
                            name="fecha_pago"
                            value={nuevoPago.fecha_pago}
                            onChange={handleInputChange}
                            className="border rounded-lg p-2 w-full"
                        />
                    </div>

                    <div className="flex justify-end space-x-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="bg-gray-500 text-white px-4 py-2 rounded"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="bg-green-500 text-white px-4 py-2 rounded"
                        >
                            Agregar Pago
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ModalAgregarPago;
